import React from "react";
import { Row } from "react-bootstrap";

const ChatHeader = () => {
  return (
    <div className="chat-header">
      <Row className="d-flex align-items-center justify-content-between flex-nowrap">
        <div className="d-flex flex-shrink-1 align-items-center p-1">
          <img
            src="/pubserv/BPMN-Chatbot-Beta/assets/chatbot-cropped.jpg"
            alt="Avatar"
            className="chat-header-avatar"
          />
          <p className="m-0 ps-2">BPMN-Chatbot++</p>
        </div>
      </Row>
    </div>
  );
};

export default ChatHeader;